import axios from 'axios';
import { CommonService } from './common.services';
export class SuiteService extends CommonService {
    async saveOrUpdate(evento, acreditado) {
        try {
            const acreditados = { "acreditados": [acreditado] };
            const response = await axios.post(this.getServerUrl() + '/mobile/update?evento=' + evento, acreditados, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data[0];
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async saveOrUpdateAll(evento, acreditados) {
        try {
            const acreditadosList = { "acreditados": acreditados };
            const response = await axios.post(this.getServerUrl() + '/mobile/update?evento=' + evento, acreditadosList, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async auth(evento, username, passwd, method) {
        try {
            const authRequest = {};
            authRequest.username = username;
            authRequest.password = passwd;
            authRequest.method = method;
            const response = await axios.post(this.getServerUrl() + '/mobile/auth?evento=' + evento, authRequest, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async changePassword(evento, hash, currentPasswd, newPasswd) {
        try {
            const authRequest = {};
            authRequest.password = currentPasswd;
            authRequest.newPassword = newPasswd;
            const response = await axios.post(this.getServerUrl() + '/mobile/changePassword?evento=' + evento + '&hash=' + hash, authRequest, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return (response.data == "Ok");
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findAcreditadoByDni(evento, dni) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/findAcreditadosByFilters?evento=' + evento + '&dni=' + dni, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data[0];
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findAcreditadoByHash(evento, hash) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/findAcreditadosByFilters?evento=' + evento + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data[0];
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findAcreditadoByFilters(evento, parameters) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/findAcreditadosByFilters?evento=' + evento + '&' + parameters, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data[0];
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findAcreditadosByFilters(evento, parameters) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/findAcreditadosByFilters?evento=' + evento + '&' + parameters, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findAcreditadosBy(evento, parameters) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/findAcreditadosByFilters?evento=' + evento + '&' + parameters, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findAcreditadosByEvento(evento) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/findAcreditadosByFilters?evento=' + evento, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findCampoBy(evento, campo) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/findCampoBy?evento=' + evento + "&idCampo=" + campo, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findCantidadBy(evento) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/findCantidadBy?evento=' + evento, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findCantidadEstadoAcreditadoBy(evento, estadoAcreditado) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/findCantidadEstadoAcreditadoBy?evento=' + evento + '&estado=' + estadoAcreditado, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findCantidadByFilters(evento, parameters) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/findCantidadByFilters?evento=' + evento + "&" + parameters, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findLecturasBy(evento, modulo) {
        return axios.get(this.getServerUrl() + '/accesos/findLecturasBy?evento=' + evento + "&modulo=" + modulo, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
    }
    async notificar(evento, idAcreditado, mailNotificacion) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/notificar?evento=' + evento + "&acreditado=" + idAcreditado + "&mailNotificacion=" + mailNotificacion, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findAcreditadosByEmpresa(evento, empresa) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/findAcreditadosByEmpresa?evento=' + evento + '&empresa=' + empresa, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async sendAccesoMeeting(evento, mail, dni) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/sendAccesoMeeting?evento=' + evento + '&mail=' + mail + '&dni=' + dni, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data == "OK";
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
}
